export default "__VITE_ASSET__1eWZolQ2__";